import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'text-encoding-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Main } from './Components/Main';
import * as serviceWorker from './serviceWorker';
import { createBrowserHistory } from 'history';
import { configureStore } from './Store/store';

if (typeof window['TextEncoder'] !== 'function') {
    const TextEncodingPolyfill = require('text-encoding-polyfill');
    window['TextEncoder'] = TextEncodingPolyfill.TextEncoder;
    window['TextDecoder'] = TextEncodingPolyfill.TextDecoder;
}
const history = createBrowserHistory();
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

ReactDOM.render(<Main store={store} history={history} />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
